/* eslint-disable putout/multiple-properties-destructuring */
import React, { Component } from 'react';
import PropTypes from 'prop-types';

import TextLabel from '../base/TextLabel';
import FilterValueComponent from './FilterValueComponent';
import FilterOperationComponent from './FilterOperationComponent';
import getStyles from './styles/Component.styles';

export default class FilterComponent extends Component {
    static defaultProps = {
        // styles: {},
    }

    static propTypes = {
        propertyName: PropTypes.string,
        propertyLabel: PropTypes.object,
        onSetFilterValue: PropTypes.func,
        onSetFilterOperation: PropTypes.func,
        operation: PropTypes.object,
        searchDialogStore: PropTypes.object,
    }

    constructor(props) {
        super(props);
        this.handleClearFilterValue = this.handleClearFilterValue.bind(this);
    }

    render() {
        const { propertyName, propertyLabel, onSetFilterValue, operation, onSetFilterOperation, searchDialogStore } = this.props;
        const styles = getStyles();
        const { heading } = propertyLabel;
        const filterValueProps = {
            propertyName,
             onSetFilterValue,
             searchDialogStore,
        };

        const filterOperationProps = {
            ...operation,
            propertyName,
            onSetFilterOperation,
            searchDialogStore,
        };
        return (
            <div
                key={ `filter_component_key${propertyName}` }
                style={ styles.container }>
                <div
                    style={ { ...styles.anchor, flexGrow: 0, height: '15px' } }>
                    <TextLabel
                        contextStyles={ { text: styles.headingLabel } }
                        key={ `filter-label-column-${propertyName}` }
                        title={ heading }>
                        { heading.toUpperCase() }
                    </TextLabel>
                </div>
                <div
                    style={ { ...styles.anchor, paddingLeft: '10px', flexGrow: 0 } }>
                    {
                        React.createElement(FilterOperationComponent, { ...filterOperationProps })
                    }
                </div>
                <div
                    style={ { ...styles.anchor, paddingLeft: '10px', flexGrow: 0, minWidth: 0, width: '92%' } }>
                    {
                        React.createElement(FilterValueComponent, { ...filterValueProps } )
                    }
                </div>
            </div>
        );
    }

    handleClearFilterValue() {
        const { onSetFilterValue, onSetFilterOperation, propertyName } = this.props;
        if (onSetFilterValue) onSetFilterValue(propertyName, null);
        if (onSetFilterOperation) onSetFilterOperation(propertyName, null);
    }
}
